import Reveal from "@/components/Reveal";
import { Radio, ArrowUpRight } from "@phosphor-icons/react";

const RadioTeaser = () => (
  <section className="border-t border-white/10 bg-surface py-20 lg:py-24" data-testid="radio-teaser">
    <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
      <Reveal>
        <a href="/radio" className="group flex flex-wrap items-center justify-between gap-8" data-testid="radio-teaser-link">
          <div className="flex items-center gap-8">
            <span className="flex h-16 w-16 shrink-0 items-center justify-center border border-fire/40 text-fire transition-colors duration-300 group-hover:bg-fire group-hover:text-ink">
              <Radio size={28} weight="light" />
            </span>
            <div>
              <p className="text-[10px] font-light uppercase tracking-[0.4em] text-fire">Nuevo · Música creada con IA</p>
              <p className="mt-2 font-serif text-4xl leading-none text-paper transition-colors duration-300 group-hover:text-fire sm:text-5xl">
                Radio <em className="italic text-gold group-hover:text-paper">Viento de Gracia</em>
              </p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <p className="max-w-xs text-sm font-light leading-relaxed text-smoke">
              Adoración original compuesta por nuestra casa con inteligencia artificial. Escúchala donde estés.
            </p>
            <ArrowUpRight size={26} weight="light" className="shrink-0 text-smoke transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-fire" />
          </div>
        </a>
      </Reveal>
    </div>
  </section>
);

export default RadioTeaser;
